import { FunctionComponent } from 'react';
import PageSidebar from 'components/PageSidebar';
import PrivatePage from './PrivatePage';
import TransportationComponent from 'components/Transportation/TransportationComponent';
import { useServiceCategoryAccess } from 'hooks';
import { Redirect } from 'react-router-dom';
import { useFilteredServicesNavigation } from 'utils/PageSidebarUtils';

interface ServicesProps {
    create: string;
}

export const Transportation: FunctionComponent<ServicesProps> = () => {
    const { isAllowed, redirectTo } = useServiceCategoryAccess('transportation');
    const { selectedKey, setSelectedKey, sidebarItems } = useFilteredServicesNavigation('transportation');

    if (!isAllowed) {
        return <Redirect to={redirectTo} />;
    }

    const sidebar = (
        <PageSidebar
            title="Services"
            items={sidebarItems}
            selectedKey={selectedKey}
            onSelect={setSelectedKey}
        />
    );

    return (
        <PrivatePage
            title="Transportation - Cuddles"
            pageName="/transportation"
            pageSidebar={sidebar}
        >
            <TransportationComponent />
        </PrivatePage>
    );
};

export default Transportation;
